import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Ladder } from 'src/models/ladder.model';
import { Level } from 'src/models/level.model';
import { Score } from 'src/models/score.model';

@Component({
  selector: 'admin-tiebreak-grid',
  templateUrl: './tiebreakgrid.component.html',
  styleUrls: ['./tiebreakgrid.component.scss']
})
export class TiebreakGridComponent implements OnInit {
  public pairingForm: FormGroup;
  public players: any = {};
  public grid: any = {};
  public Object: any = Object;
  public total: any = [];
  public winnercol: number;

  constructor(private http: HttpClient, private fb: FormBuilder) {
  }

  ngOnInit(): void {
    this.http.get('/tiebreaker/grid').subscribe(
      (resp: any) => {
        // hate using anony objects here, but it's the easiest way to get this data
        this.players = resp.players;
        this.grid = resp.grid;

        // sum each column
        let idx = 0;
        for (const p in this.players) {
          let temp = [];
          for (const elm2 in this.players) {
            temp.push(parseInt(this.grid[elm2][idx], 10) || 0);
          }
          this.total.push(temp.reduce((partialSum, a) => partialSum + a, 0));
          idx++;
        }
        const max = Math.max(...this.total);
        this.winnercol = this.total.indexOf(max);
      }
    )
  }
}
